import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Service/user-management.service';
const trimValidator: ValidatorFn = (text: FormControl) => {
  if (text.value.startsWith(' ')) {
    return {
      trimError: { value: 'text has leading whitespace' },
    };
  }
  if (text.value.endsWith(' ')) {
    return {
      trimError: { value: 'text has trailing whitespace' },
    };
  }
  return null;
};

@Component({
  selector: 'app-video-category-manage',
  templateUrl: './video-category-manage.component.html',
  styleUrls: ['./video-category-manage.component.scss'],
})
export class VideoCategoryManageComponent implements OnInit {
  form: FormGroup;
  submitted = false;
  imageSrc: string | ArrayBuffer;
  uploadedImage: File;
  categoryForm: FormGroup;
  success;
  insertscheme;
  alertMessage: any;
  getGovtSchemes: any[];
  dataSource: any;
  selectedIndex: number;
  paginator: any;
  reg: string | RegExp;
  remarkList;
  activeCategoryId;
  disable = false;
  showFileError: boolean;
  priorityList:any;
  constructor(
    private datepipe: DatePipe,
    private router: Router,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<VideoCategoryManageComponent>
  ) { }

  ngOnInit(): void {
    this.categoryForm = this.fb.group({
      categoryName: ['', [Validators.required]],
      image: ['', [Validators.required]],
    });

    this.spinner.show();

    setTimeout(() => {
      this.spinner.hide();
    }, 4000);

    let categoryName = '';
    let result = categoryName.trim();
    this.getcategoryforFilter();
    this.getpriority();
  }
  govtschemedata;
  govtschemedatalist;
  categorydatalist = [];
  categorydata;
  categoryId;
  requirederror;
  getcategoryId(id) {
    this.categoryId = id;
  }
  get f() {
    return this.categoryForm.controls;
  }

  getcategoryforFilter() {
    this._userService.getVideoCategory().subscribe((data) => {
      this.categorydata = data;
      this.categorydatalist = this.categorydata.result.data;
    });
  }

  getpriority(){
    this._userService.getVideoPriorityList().subscribe((res:any)=>{
      this.priorityList = res.result.data;
    })
  }
  
  selectedPriority(id, value){
    let body={
      "categoryID": id,
      "priority": value
    }
    this._userService.updateVideoPriority(body).subscribe((res:any)=>{
      this.getcategoryforFilter();
      this.toastr.success(res.result.message);
    })
  }

  getActiveVideoCategory() {
    this.spinner.show();
    var postdata = {
      removeCategoryList: this.selectedItems,
    };
    this._userService.getActiveVideoCategory(postdata).subscribe((data) => {
      this.alertMessage = data['result'];
    });
    return this.alertMessage;
  }

  addCategories() {
    // this.showFileError=this.categoryForm.value.image
    if (this.categoryForm.value.image) {
      this.categoryForm.get('image').setErrors(null);
    } else {
      this.categoryForm.get('image').setErrors({ required: true });
      this.showFileError = true;
    }
    if (this.categoryForm.valid) {
      const formData: FormData = new FormData();
      formData.append('Image', this.categoryForm.get('image').value);
      formData.append(
        'categoryName',
        this.categoryForm.get('categoryName').value
      );
      this._userService.postCategory(formData).subscribe((data) => {
        if (data['result'].data == 1) {
          this.toastr.success(data['result'].message, 'Success', {
            timeOut: 3000,
          });
          this.categoryForm.reset();
          this.getpriority();
          this.getcategoryforFilter();
        } else {
          this.toastr.error(data['result'].message, 'Error', {
            timeOut: 3000,
          });
        }
      });
    }else{
      this.toastr.error("Please fill the details")
    }
  }

  onSubmit() {
    if (this._userService.form.valid) {
      this._userService.insertscheme(this._userService.form.value);

      this._userService.form.reset();
      this._userService.success('Submitted successfully');
      this.onClear();
    }
  }
  selectedItems: any = [];
  itemToDelete(categoriesItems, event) {
    if (this.selectedItems.find((x) => x == categoriesItems)) {
      this.selectedItems.splice(this.selectedItems.indexOf(categoriesItems), 1);
    } else {
      this.selectedItems.push(categoriesItems);
    }
  }

  onClear() {
    this.dialogRef.close();
    // setTimeout('location.reload(true);', 500);
  }
  /*model pop up same page  */
  deleteCategories() {
    if (this.selectedItems.length > 0) {
      this.selectedItems.forEach((element) => {
        element.categoryId;
        this.activeCategoryId = element.categoryId;
      });
      var postdata = {
        // "removeCategoryList ": this.selectedItems
        removeCategoryList: [
          {
            categoryID: this.activeCategoryId,
            remark: 'test',
          },
        ],
      };
      this._userService.getActiveVideoCategory(postdata).subscribe((resp) => {
        if (resp['result']['data'] == 1) {
          var dialogRef = this.dialog.open(DeleteCategoryPopup, {
            width: '35%',
            height: 'auto',
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result.result === 'Yes') {
              this.selectedItems.map((ele) => {
                ele.remark = result.remark;
                this.remarkList = result.remark;
                delete ele.categoryName;
              });
              const deleteBody = {
                removeCategoryList: [
                  {
                    categoryID: String(this.activeCategoryId),
                    remark: this.remarkList,
                  },
                ],
              };
              this._userService
                .removeVideoCategory(deleteBody)
                .subscribe((data) => {
                  if (data['result'].data == 1) {
                    this.toastr.success(data['result'].message, 'Success', {
                      timeOut: 3000,
                    });
                    this.selectedItems = [];
                    this.getcategoryforFilter();
                  }
                });
            }
          });
        } else {
          this.toastr.error(resp['result']['message'], 'Error', {
            timeOut: 3000,
          });
        }
      });
    } else {
      this.toastr.warning('Please select any one category!', 'Info', {
        timeOut: 3000,
      });
    }
  }

  imageFileSelected(event) {
    this.uploadedImage = event.target.files[0];
    let imageName = this.uploadedImage.name;
    let fileExtensionError: boolean;
    // check file type
    var allowedExtensions =
      ["jpg", "jpeg", "png", "JPG", "JPEG", "JFIF", "BMP", "SVG"];
    let fileExtension = imageName.split('.').pop();

    if (this.isInArray(allowedExtensions, fileExtension)) {
      fileExtensionError = false;
    } else {
      fileExtensionError = true;
    }
    // upload correct file
    if (fileExtensionError) {
      this.toastr.error("Upload correct file")
    } else {
      this.categoryForm.get('image')?.setValue(this.uploadedImage);
      if (event.target.files && event.target.files[0]) {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (e) => (this.imageSrc = reader.result);

        reader.readAsDataURL(file);
      }
      this.toastr.success("File added successfully")
    }
  }

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }
}
/* */
@Component({
  selector: 'delete-category-popup',
  templateUrl: 'delete-category-popup.html',
})
export class DeleteCategoryPopup {
  formDelete: FormGroup;
  response;
  categoryId;

  constructor(
    public dialogRef: MatDialogRef<DeleteCategoryPopup>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.formDelete = this.fb.group({
      //  categoryID: ['', [Validators.required]],
      // categoryName: ['', [Validators.required]],
      Remark: ['', [Validators.required]],
    });
  }
  onSubmit(value: any) {
    if (this.formDelete.valid) {
      var deleteItems = {
        result: value,
        remark: this.formDelete.value.Remark,
      };
      this.dialogRef.close(deleteItems);
    } else {
      this.toastr.error('Please Enter Valid Remark.');
    }
  }
  onNoClicks(value): void {
    this.dialogRef.close(value);
  }

  get f() {
    return this.formDelete.controls;
  }
}
